/**
 * The entries of `candidates` the signal library does not hold yet: a library entry matches by
 * its `query`, case-insensitively, and a name repeated in `candidates` is added once. The
 * drawer saves exactly these, and its `signal.add` counts them, so the two cannot disagree.
 */
export function signalsToAdd(library, candidates) {
  const have = new Set((library ?? []).map((p) => String(p?.query ?? "").toLowerCase()));
  const out = [];
  for (const c of candidates ?? []) {
    const k = String(c?.query ?? "").toLowerCase();
    if (!k || have.has(k)) continue;
    have.add(k);
    out.push(c);
  }
  return out;
}

/**
 * `signalsToAdd` against `ref.current` (the library as last rendered), reserving the result in
 * `ref.current` at once: a second add that resolves before React commits the first sees the
 * first's signals and does not count them again.
 */
export function reserveSignals(ref, candidates) {
  const added = signalsToAdd(ref.current, candidates);
  if (added.length) ref.current = [...(ref.current ?? []), ...added];
  return added;
}
